<label class="custom-checkbox">
  <input type="checkbox" [formControl]="control" />
  <span
    class="fa-solid fa-eye checked"
    [ngClass]="control.disabled ? 'disabled' : ''"
  ></span>
  <span
    class="fa-solid fa-eye-slash unchecked"
    [ngClass]="control.disabled ? 'disabled' : ''"
  ></span>
</label>
